import React, { useCallback, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import {
  BooleanInput,
  CreateProps,
  SimpleForm,
  TextInput,
  required,
  useRedirect,
  useRefresh,
} from "react-admin";
import CustomAddressAutoCompleteInput from "./components/CustomAddressAutoCompleteInput";
import CustomOneMap from "./components/CustomOneMap";
import { GetParam } from "utils/tools";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import SanitizedGrid from "components/SanitizedGrid";
import LatLngInput from "./components/LatLngInput";
import CreateWrapper from "../../components/CreateWrapper";

interface ICustomRedirect {
  data: ICcaFixedLocationDropOff;
}

const CcaFixedLocationDropOffCreate = (props: CreateProps) => {
  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const [markerPosition, setMarker] = useState({
    lat: "1.343877",
    lng: "103.846485",
  });

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Areas", link: `/schools/${param.get("schoolId")}/show/3` },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = ({ data }: ICustomRedirect) => {
    redirect(`/schools/${data.schoolId}/show/3`);
    refresh();
  };

  const updateMarkerPosition = useCallback(
    ({ type, coordinate }: any) => {
      type === "lat" && setMarker({ lat: coordinate, lng: markerPosition.lng });
      type === "lng" && setMarker({ lat: markerPosition.lat, lng: coordinate });
    },
    [markerPosition.lat, markerPosition.lng]
  );

  const onMapClick = (data: { lat: number; lng: number }) => {
    setMarker({
      lat: data.lat.toPrecision(15),
      lng: data.lng.toPrecision(15),
    });
  };

  const transform = async (data: any) => {
    if (data.isActive) {
      data.status = "active";
    } else {
      data.status = "inactive";
    }

    delete data.isActive;

    return data;
  };

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New CCA Fixed Location Drop Off"
        transform={transform}
        onSuccess={CustomRedirect}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <CustomAddressAutoCompleteInput
                label="Postal Code *"
                source="postalCode"
                referenceSource="ccaLocationData"
                parentCallback={setMarker}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={2}>
              <TextInput label="Unit No." source="unitNumber" />
            </Grid>
            <Grid item xs={2}>
              <TextInput
                label="Block No."
                source="blockNumber"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Building Name" source="building" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="Address"
                source="address"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Street" source="street" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">
                Select Location for fixed location drop off on Map
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <CustomOneMap center={markerPosition} onMapClick={onMapClick} />
            </Grid>
            <Grid item xs={6}></Grid>

            <Grid item xs={4}>
              <LatLngInput
                lat={markerPosition.lat}
                lng={markerPosition.lng}
                updateLatLng={updateMarkerPosition}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={6}>
              <BooleanInput
                source="isActive"
                label="Set this fixed location drop off as Active"
                defaultValue={true}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default CcaFixedLocationDropOffCreate;
